export const listCalendarEventsInRange = async (
  accessToken: string,
  startDate: Date,
  endDate: Date,
  maxResults?: number
) => {
  const timeMin = encodeURIComponent(startDate.toISOString());
  const timeMax = encodeURIComponent(endDate.toISOString());

  const url =
    `https://www.googleapis.com/calendar/v3/calendars/primary/events` +
    `?timeMin=${timeMin}` +
    `&timeMax=${timeMax}` +
    (maxResults ? `&maxResults=${maxResults}` : "") +
    // `singleEvents=true` forces recurring events to be expanded into single
    // instances so that they respect the provided time range.
    `&singleEvents=true` +
    // Ordering by startTime makes it easier to split the events into
    // "before/after/today" buckets later on.
    `&orderBy=startTime`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch calendar events: ${response.statusText}`);
  }

  const data = await response.json();
  console.log("Calendar events in range:", data);
  return data.items;
};
